// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ieo0","top":"styles_top__1y1tb"};